module.exports = __webpack_public_path__ + "static/assets/0d2125bd7dc85af83656ff7e4b894393.svg";